import moment from 'moment'

export const getTimestampPeriod = function (ts, period) {
    return +ts - +ts % ((+period || 1) * 60);
}

export const getStartTimestampPeriod = function (tsTo, period) {
    const periodSeconds = period === '1D' ? (60 * 60 * 24)
        : period === 'D' ? (60 * 60 * 24 * 3)
            : +period * 60;

    const tsFrom = +tsTo - (+periodSeconds * 20)
    return tsFrom;
}

const buildQueryArray = data => {
    let queryArray = '';

    if (data && data[0] && data[1]) {
        data[1].reduce((acc, cur) => {
            queryArray = `${queryArray}${data[0]}[]=${encodeURIComponent(cur)}&`;

            return acc;
        }, {});
        queryArray = queryArray.substring(0, queryArray.length - 1);
    }

    return queryArray;
};

// tslint:disable:no-any
export const buildQueryString = function (action, key) {
    return Object.entries(action)
        .filter(w => w[1] !== '' && w[1] !== undefined)
        .map((k) => {
            const param = k[0] === 'page' ? Number(k[1]) + 1 : k[1];
            return (
                Array.isArray(param) ? buildQueryArray(k) : `${k[0]}=${encodeURIComponent(param)}`
            );
        })
        .join('&')
}

// const DEFAULT_TRADING_VIEW_INTERVAL = '360';
const DEFAULT_TRADING_VIEW_INTERVAL = '120';


export const periodsMapNumber = {
    '1m': 1,
    '5m': 5,
    '15m': 15,
    '30m': 30,
    '1h': 60,
    '2h': 120,
    '4h': 240,
    '6h': 360,
    '12h': 720,
    '1d': 1440,
    '3d': 4320,
    '1w': 10080
};

export const periodsMapString = {
    1: '1m',
    5: '5m',
    15: '15m',
    30: '30m',
    60: '1h',
    120: '2h',
    240: '4h',
    360: '6h',
    720: '12h',
    1440: '1d',
    4320: '3d',
    10080: '1w'
};

export const periodStringToMinutes = (period) => periodsMapNumber[period] || +DEFAULT_TRADING_VIEW_INTERVAL;
export const periodMinutesToString = (period) => periodsMapString[period] || periodsMapString[+DEFAULT_TRADING_VIEW_INTERVAL];

export const klineArrayToObject = (el) => {
    const [time, open, high, low, close, volume] = el.map((e) => {
        switch (typeof e) {
            case 'number':
                return e;
            case 'string':
                return Number.parseFloat(e);
            default:
                throw (new Error(`unexpected type ${typeof e} in kline: ${el}`));
        }
    });
    const s = {
        time: time * 1e3,
        open,
        high,
        low,
        close,
        volume,
    }
    return s;
};

export const getLanguageFromURL = function () {
    const regex = new RegExp('[\\?&]lang=([^&#]*)');
    const results = regex.exec(window.location.search);
    return results === null ? null : decodeURIComponent(results[1].replace(/\+/g, ' '));
}

export const stdTimezoneOffset = (date) => {
    const jan = new Date(date.getFullYear(), 0, 1);
    const jul = new Date(date.getFullYear(), 6, 1);
    return Math.max(jan.getTimezoneOffset(), jul.getTimezoneOffset());
}

export const generateCSV = (htmlTable, fileName) => {
    try {
        const table = htmlTable
        const tableRows = []
        const rows = table.querySelectorAll('tr')
        rows.forEach((row) => {
            const columns = row.querySelectorAll('th, td')
            const list = [].slice.call(columns)
            const innertext = list.map((e) => {
                return e.innerText.replaceAll(',', '')
            }).join(',')
            tableRows.push(innertext)
        })
        // let csvFile = 'data:text/csv;charset=utf-8,'
        let csvFile = ''
        tableRows.forEach((rowArray) => {
            csvFile += rowArray + '\r\n'
        })
        // const encodedUri = encodeURI(csvFile)
        const link = document.createElement('a')
        const blob = new Blob(['\ufeff', csvFile])
        const url = URL.createObjectURL(blob)
        link.hreflang = 'mn-mn'
        // link.setAttribute('href', encodedUri)
        link.setAttribute('href', url)
        link.setAttribute('download', fileName + '.csv')
        document.body.appendChild(link)
        link.click()
        return true
    } catch (e) {
        console.error(e)
    }
}

export const tradeHour = {
    'start': 10,
    'end': 13,
}

export const ubxTradeHour = {
    'start': 9,
    'end': 16,
}

const resolutionToMinutes = function (r) {
    const minutes = parseInt(r, 10);
    if (r === '1D') {
        return 1440;
    } else if (r === 'D') {
        return 4320;
    } else if (!isNaN(minutes)) {
        return minutes;
    } else {
        return 1;
    }
};

export const findLatestTradingTime = (timestamp, resolution, first, exchange_server_code) => {
    const date = new Date()
    const now = moment()
    const hour = now.hour()
    const minute = now.minute()
    const seconds = now.seconds()

    const res = resolutionToMinutes(resolution)
    const resInMinutes = res * 60

    const startHour = exchange_server_code === 'ubx' ? ubxTradeHour.start : tradeHour.start
    const endHour = exchange_server_code === 'ubx' ? ubxTradeHour.end : tradeHour.end
    const to = moment.unix(timestamp)

    // console.log('TIMESTAMP: ', timestamp);
    // return timestamp

    // if (to.hour() >= endHour && !first) {
    //     to.set({ hour: endHour, second: 0, minute: 0 })
    //     to.set({ hour: endHour })
    //     return to.unix()
    // }

    // Хэрэв интервал нь 1 өдөр байвал дараагийн өдрийн 00:00 цагаар тооцно.
    // 2 салгаж fetch хийдэг(a->b, b->c) тул 2 уулангийн нь to-г нь адилхан өдөр болгохоор зогсолтгүй дуудаж ажиллахгүй
    // байсан тул эхний буюу firstDataRequest үед л тохируулахаар болгов.
    if (resolution === '1D' && first) {
        date.setDate(date.getDate() + 1)
        date.setHours(0, 0, 0, 0)
        return Math.floor(date.getTime() / 1000)
    }

    // Арилжааны цаг бол
    // Одоогийн цагтай хамгийн ойр байх ирээдүйн интервальтай цагийг тооцож илгээх
    // Жишээ нь: 15мин интервал, 12.09 цаг болж байвал 12.15 гэж тооцоолно.
    // Хэрэв ингэхгүй бол сервер нь 12.00 - 12.09 хоорондох датаг буцаахгүй.
    if (hour >= startHour && hour <= endHour) {
        if (first) {
            const t = minute * 60 + seconds
            let x = parseInt(t / resInMinutes)
            if (t % resInMinutes > 0) x += 1
            to.set({ minute: 0, second: 0, millisecond: 0 })
            to.add(res * x, 'minutes')
            return to.unix()
        }
        else return timestamp
    } else if (hour > endHour && first) {
        to.set({ hour: endHour, second: 0, minute: 0 })
        to.set({ hour: endHour })
        return to.unix()
    } else {
        return timestamp
    }

    // else if (hour > endHour) { // Арилжаа дууссаны дараа
    //     to.set({ hour: endHour, second: 0, minute: 0 })
    //     return to.unix()
    //     // date.setHours(endHour, 0, 0, 0)
    //     // return Math.floor(date.getTime() / 1000)
    // } else {
    //     // date.setDate(date.getDate() - 1)
    //     // date.setHours(endHour, 0, 0, 0)
    //     // return Math.floor(date.getTime() / 1000)
    //     
    //     to.add(-1, 'day')
    //     to.set({ hour: endHour })

    //     return to.unix()
    // }
}

export const calculateStartDate = (preStart, preEnd, end) => {
    return preStart - (preEnd - end)
}
